import * as React from "react";
import * as ReactDOM from "react-dom";

import { Helmet } from "react-helmet";
import App from "./App";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

import * as RNDo from "./react-native-ui-kits.jpg";

ReactDOM.render(
    <div>
        <Helmet>
            <meta property="og:title" content="React Native Starter Kits" />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={RNDo} />
            <meta property="og:description" content="Turnkey solutions for your next React Native project" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:image:width" content="1920" />
            <meta property="og:image:height" content="1440" />
        </Helmet>
        <App />
    </div>,
    document.getElementById("root") as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx